import { put, call, take, fork } from 'redux-saga/effects'
import { getCardService } from 'src/api/card'
import { getCardSuccess } from 'src/reducers/card/action'
import { GET_CARD } from 'src/reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* getCardFlow(payload) {
  const { id, callback } = payload
  try {
    let response = null
    response = id != null ? yield call(getCardService, id) : null
    callback && callback(response)
    yield put(getCardSuccess(response))
    if (response) {
      yield put(operationSuccess())
    }
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* getCardWatcher() {
  while (true) {
    const action = yield take(GET_CARD)
    const { payload } = action

    yield fork(generalSaga, getCardFlow, payload)
  }
}
